<template>
  <el-row class="panel-item">
    <el-col :span="8" v-if="title[2] || title.length === 3">
      <label>{{ title[0] }}</label>
      <span>{{ data[0] || "--" }}</span>
    </el-col>
    <el-col :span="8" v-if="title[2] || title.length === 3">
      <label>{{ title[1] }}</label>
      <span>{{ title[1] === "" ? data[1] : data[1] || "--" }}</span>
    </el-col>
    <el-col :span="8" v-if="title[2]">
      <label>{{ title[2] }}</label>
      <span>{{ title[2] === "" ? data[2] : data[2] || "--" }}</span>
    </el-col>
    <div style="width: 100%" v-else-if="title[1] && title.length < 3">
      <el-col :span="11">
        <label>{{ title[0] }}</label>
        <span>{{ data[0] || "--" }}</span>
      </el-col>
      <el-col :span="11" :offset="1">
        <label>{{ title[1] }}</label>
        <span>{{ data[1] || "--" }}</span>
      </el-col>
    </div>
    <el-col :span="23" v-if="!title[1] && title.length < 3">
      <label>{{ title[0] }}</label>
      <span>{{ data[0] || "--" }}</span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    title: Array,
    data: Array,
  },
  // methods
};
</script>

<style lang="less" scoped>
@import "~@/styles/common.less";

.panel-item {
  display: flex;
  align-items: stretch;
  padding: 0 10px;
  .el-col {
    display: flex;
    padding-bottom: 10px;
    padding-top: 10px;
    border-bottom: 1px solid #ebeef5;
    span {
      flex: 1;
    }
  }
  label {
    width: 150px;
    display: inline-block;
    color: @color--info;
  }
}
</style>
